import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { AdsProvider } from "./context/AdsContext";
import HomePage from "./pages/HomePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ArticleFormPage from "./pages/ArticleFormPage";
import VideoFormPage from "./pages/VideoFormPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import TagListPage from "./pages/TagListPage";
import CategoryPage from "./pages/CategoryPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

function App() {
  // Continuously remove any "Made with Emergent" badge that the platform
  // tries to inject into the DOM. Runs in the React bundle so it cannot be
  // stripped by edge HTML rewriters.
  useEffect(() => {
    const kill = () => {
      const b = document.getElementById("emergent-badge");
      if (b && b.parentNode) b.parentNode.removeChild(b);
    };
    kill();
    const observer = new MutationObserver(kill);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    const interval = setInterval(kill, 500);
    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <AdsProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/article/:id" element={<ArticleDetailPage />} />
                <Route path="/tag/:tag" element={<TagListPage />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/admin" element={<AdminLoginPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                <Route path="/admin/articles/create" element={<ArticleFormPage />} />
                <Route path="/admin/articles/edit/:id" element={<ArticleFormPage />} />
                <Route path="/admin/videos/create" element={<VideoFormPage />} />
                <Route path="/admin/videos/edit/:id" element={<VideoFormPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </AdsProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
